import { render, staticRenderFns } from "./TSCardDeckEffects.vue?vue&type=template&id=84d1874c&scoped=true&"
import script from "./TSCardDeckEffects.vue?vue&type=script&lang=js&"
export * from "./TSCardDeckEffects.vue?vue&type=script&lang=js&"
import style0 from "./TSCardDeckEffects.vue?vue&type=style&index=0&id=84d1874c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1874c",
  null
  
)

export default component.exports